/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { P } from '../atoms';
import { fadeIn, animationUsage, fadeOut } from '../tokens/Animations';
import Colours from '../tokens/colours';
import FontSizes from '../tokens/fontSizes';
import MediaQueries from '../tokens/MediaQueries';
const getStyles = createUseStyles({
    ...fadeIn,
    ...fadeOut,
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
        width: '100%',
        height: '5.5rem',
        borderRadius: 4,
        margin: 8,
        zIndex: 9998,
        [MediaQueries.desktop]: {
            flexDirection: 'row',
            alignItems: 'center',
            height: '4rem',
            width: '16.0rem',
            justifyContent: 'flex-start',
            margin: '0 0 3.2rem 0',
            paddingLeft: 8,
        },
        '&:hover': {
            extend: 'itemActive',
            cursor: 'pointer',
            backgroundColor: Colours.septernary,
        },
    },
    itemActive: {
        backgroundColor: Colours.quarternary,
    },
    anchor: {
        textDecoration: 'none',
        ...animationUsage('$fadeOut', '0.5s'),
        [MediaQueries.desktop]: {
            margin: '0 0 0 1.6rem',
            ...animationUsage('$fadeIn', '0.5s'),
        },
    },
    paragraphNormal: {
        color: Colours.sexternary,
    },
    paragraphSelected: {
        color: Colours.primary,
    },
    paragraph: {
        fontSize: FontSizes.Small,
        [MediaQueries.desktop]: {
            fontSize: FontSizes.Regular,
        },
    },
    wrapper: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 10,
    },
    icon: {
        marginBottom: 4,
        [MediaQueries.desktop]: { margin: 0 },
    },
    SVGdefault: {
        display: 'none',
        backgroundColor: Colours.sexternary,
    },
    hidden: {
        [MediaQueries.desktop]: {
            display: 'none',
        },
    },
    logoCentered: {
        [MediaQueries.desktop]: {
            justifyContent: 'center',
            paddingLeft: 0,
            width: 40,
        },
    },
});
const NavOption = (props) => {
    const { icon, optionName, selected, className, isNavbarHovered, to, onClick, } = props;
    const styles = getStyles();
    return (React.createElement("li", { className: classNames(styles.root, {
            [styles.itemActive]: selected === optionName,
        }, { [styles.logoCentered]: !isNavbarHovered }, className) },
        React.createElement(Link, { to: to, id: optionName, onClick: e => onClick(e), className: classNames(styles.wrapper) }),
        icon,
        React.createElement(P, { className: classNames(styles.paragraph, selected === optionName
                ? styles.paragraphSelected
                : styles.paragraphNormal, styles.anchor, {
                [styles.hidden]: !isNavbarHovered,
            }) }, optionName)));
};
export default NavOption;
//# sourceMappingURL=NavOption.js.map